<div class="page-body">
  <div *ngIf="!loading && internalServerError">
    <div class="error-wrapper">
      <div class="contents-container">
        <h3 class="heading">Etwas ist schief gelaufen.</h3>
        <p class="info-text">
          Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
          weiterhin besteht.
        </p>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <div class="installments-container">
        <ng-container
          *ngFor="let loanOption of presentedLoanOptions; let i = index"
        >
          <app-installments-item
            [isFirstItem]="i === 0"
            [isLastItem]="
              i === availableLoanOptions.length - 1 &&
              equalOrLessThanThreeLoanOptions
            "
            [title]="loanOption.title"
            [selected]="loanOption === selectedLoanOption"
            (click)="
              loanOption !== selectedLoanOption && selectInstallment(loanOption)
            "
            [bulletPoints]="loanOption.bulletPoints"
            [link]="loanOption.link"
            [radioButtonColor]="loanOption.radioButtonColor"
            [color]="loanOption.color"
            [badgeText]="loanOption.badgeText"
          ></app-installments-item>
        </ng-container>
        <button
          *ngIf="!equalOrLessThanThreeLoanOptions"
          class="installments-button"
          (click)="expanded ? viewReducedLoanOptions() : viewAllLoanOptions()"
        >
          {{ expanded ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
          <img
            class="installment-img"
            [src]="
              expanded
                ? 'assets/icon/Arrow-Up.svg'
                : 'assets/icon/Arrow-Down.svg'
            "
          />
        </button>
      </div>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="total-amount" *ngIf="state.totalCheckoutValue">
            <p>Gesamtbetrag:</p>
            <p>{{ state.totalCheckoutValue | value }}</p>
          </div>

          <div class="button-container">
            <zaver-primary-button
              [text]="'Kauf abschließen'"
              [disabled]="navigationInProgress"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>

          <p class="agb-info">
            Indem Sie Kauf abschließen klicken, stimmen<br />
            Sie den

            <span *ngIf="state?.checkoutCustomizations?.merchantTermsUrlText">
              <a
                [href]="state?.checkoutCustomizations?.merchantTermsUrl"
                target="_blank"
              >
                {{ state?.checkoutCustomizations?.merchantTermsUrlText }}
              </a>
            </span>

            <span *ngIf="!state?.checkoutCustomizations?.merchantTermsUrlText">
              <a
                [href]="state?.checkoutCustomizations?.merchantTermsUrl"
                target="_blank"
              >
                AGB
              </a>
              von {{ state?.checkoutCustomizations?.merchantName }} zu.
            </span>
          </p>

          <p class="loan-terms-string">{{ currentLoanTermsStr }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  [buttonText]="'Schließen'"
  *ngIf="selectorItems && modalActive"
  id="details-modal"
  (onClose)="toggleModal()"
>
  <app-selector #selector [selectorItems]="selectorItems"></app-selector>
</zaver-checkout-modal>
